
<div class="space-y-6">
  <div>
    <h1 class="text-2xl font-bold text-gray-800">{{ 'backOffice.sidebar.settings' | translate }}</h1>
    <p class="text-gray-600 mt-1">{{ 'backOffice.settings.description' | translate }}</p>
  </div>

  <div class="flex flex-col lg:flex-row gap-8 items-start">
    <!-- Sidebar -->
    <div class="w-full lg:w-1/4 xl:w-1/5 flex-shrink-0">
      <div class="bg-white p-2 lg:p-3 rounded-md shadow-sm overflow-x-auto">
        <nav class="flex lg:block space-x-2 lg:space-x-0 lg:space-y-1 min-w-max lg:min-w-0 pb-2 lg:pb-0">
          @for(item of navItems(); track item.id) {
            @if(item.sectionHeader) {
                <div class="hidden lg:block px-4 py-2 mt-2 text-xs font-bold text-gray-400 uppercase tracking-wider">
                    {{ item.sectionHeader }}
                </div>
            }
            <button (click)="setView(item.id)" 
              [class]="'text-left px-4 py-2.5 rounded-md text-sm font-medium transition-colors flex items-center gap-3 whitespace-nowrap ' + (activeView() === item.id ? 'bg-emerald-100 text-emerald-800 font-semibold' : 'hover:bg-gray-100 text-gray-700 bg-slate-50 lg:bg-transparent')">
              <i [class]="item.icon + ' w-5 text-center'"></i>
              <span>{{ item.labelKey | translate }}</span>
            </button>
          }
        </nav>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-grow min-w-0 w-full">
      @switch (activeView()) {
        @case ('general') {
          <div class="space-y-6">
            <app-portal-customizer></app-portal-customizer>
          </div>
        }
        @case ('clinic_config') {
          <app-clinic-settings></app-clinic-settings>
        }
        @case ('pos_devices') {
          <app-pos-device-management></app-pos-device-management>
        }
      }
    </div>
  </div>
</div>
